var React = require('react');

function IconCheckmark (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9 21.035l-9-8.638 2.791-2.87 6.156 5.874 12.21-12.436 2.843 2.817z"}));
}

IconCheckmark.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = IconCheckmark;

IconCheckmark.default = IconCheckmark;
